import { Check, Minus, X } from "lucide-react";

export const Section = ({ id, over, title, lead, children, className = "" }) => (
  <section id={id} className={`border-t border-slate-800/70 ${className}`}>
    <div className="max-w-7xl mx-auto px-6 py-20 lg:py-28">
      {over && <p className="font-mono text-xs tracking-[0.2em] text-sky-400 mb-3">{over}</p>}
      {title && <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight max-w-3xl mb-4">{title}</h2>}
      {lead && <p className="text-slate-400 text-base md:text-lg max-w-2xl mb-12 leading-relaxed">{lead}</p>}
      {children}
    </div>
  </section>
);

export const BrowserFrame = ({ src, alt, className = "" }) => (
  <div className={`rounded-xl border border-slate-700/80 bg-slate-900 shadow-[0_30px_80px_-20px_rgba(56,189,248,0.25)] overflow-hidden ${className}`}>
    <div className="flex items-center gap-1.5 px-3 h-7 bg-slate-800/80 border-b border-slate-700/60">
      {["bg-rose-400/70", "bg-amber-400/70", "bg-emerald-400/70"].map((c) => <span key={c} className={`h-2.5 w-2.5 rounded-full ${c}`} />)}
    </div>
    <img src={src} alt={alt} className="w-full block" loading="lazy" />
  </div>
);

export const Mark = ({ v }) => {
  if (v === "✓") return <Check className="h-5 w-5 text-emerald-400 mx-auto" aria-label="Oui" />;
  if (v === "✗") return <X className="h-5 w-5 text-slate-600 mx-auto" aria-label="Non" />;
  return <span className="inline-flex items-center gap-1 text-xs text-amber-300" title="Partiel, selon l'offre ou en option"><Minus className="h-4 w-4" />partiel</span>;
};
